import { Sparkles, Building, Layers, Wrench } from "lucide-react";

export const STEPS = 5;

export const PROJECT_TYPES = [
  {
    key: "enduit-ravalement",
    label: "Enduit projeté / ravalement",
    Icon: Sparkles,
    desc: "Rénovation complète, enduit gratté, taloché ou écrasé",
  },
  {
    key: "ite",
    label: "Isolation thermique par l'extérieur",
    Icon: Layers,
    desc: "ITE éligible MaPrimeRénov', réduction consommation",
  },
  {
    key: "rejointoiement",
    label: "Rejointoiement",
    Icon: Building,
    desc: "Reprise des joints de briques ou de pierre",
  },
  {
    key: "autre",
    label: "Autre projet façade",
    Icon: Wrench,
    desc: "Nettoyage, hydrofuge, fissures, imitation pierre…",
  },
];

export const DAY_OPTIONS = [
  "Lundi",
  "Mardi",
  "Mercredi",
  "Jeudi",
  "Vendredi",
  "Samedi",
];

export const HOUR_OPTIONS = [
  "8h",
  "9h",
  "10h",
  "11h",
  "12h",
  "14h",
  "15h",
  "16h",
  "17h",
  "18h",
];
